var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39822 0.492248C8.66529 0.253658 9.066 0.287571 9.29323 0.567997C9.52046 0.848422 9.48816 1.26917 9.22109 1.50776L5.51734 4.81653C5.40283 4.91882 5.09466 5.15836 5.09466 5.15836C5.09466 5.15836 4.82819 4.92986 4.70781 4.82813L0.792515 1.51935C0.519345 1.2885 0.476129 0.868835 0.695989 0.582007C0.915849 0.295178 1.31553 0.249801 1.5887 0.480654L5.09466 3.4435L8.39822 0.492248Z",
    fill: "#979797"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.39822 0.492248C8.66529 0.253658 9.066 0.287571 9.29323 0.567997C9.52046 0.848422 9.48816 1.26917 9.22109 1.50776L5.51734 4.81653C5.40283 4.91882 5.09466 5.15836 5.09466 5.15836C5.09466 5.15836 4.82819 4.92986 4.70781 4.82813L0.792515 1.51935C0.519345 1.2885 0.476129 0.868835 0.695989 0.582007C0.915849 0.295178 1.31553 0.249801 1.5887 0.480654L5.09466 3.4435L8.39822 0.492248Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.714355,
    y: -3.66666,
    width: 11.4286,
    height: 12,
    fill: "#393D50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownChevron);
export default __webpack_public_path__ + "static/media/down-chevron.28fdd906afbde81f580f46304e70c7eb.svg";
export { ForwardRef as ReactComponent };